import React, { useMemo } from "react";
import { Typography, Box, useTheme } from "@mui/material";
import AccordionComponent from "../components/Accordion";
import AssignmentSection from "./AssignmentSection";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const UserDetail = ({ user, refetchUserDetail }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  if (!user) {
    return (
      <Box textAlign="center" py={4}>
        <Typography variant="body1" color="text.secondary" fontStyle="italic">
          No se encontró información del usuario
        </Typography>
      </Box>
    );
  }

  const accordionInfo = useMemo(() => {
    if (!user.applications?.length) return [];

    return user.applications.map((app) => ({
      key: `app-${app.id}`,
      title: <Typography variant="subtitle1">Aplicación: {app.title}</Typography>,
      details: (
        <Box sx={{ pl: { xs: 2, md: 4 }, py: 1 }}>
          <AssignmentSection assign={app.assignment} appId={app.id} allowedForms={app.allowedForms} refetchUserDetail={refetchUserDetail} />
        </Box>
      ),
    }));
  }, [user, refetchUserDetail]);

  return (
    <Box
      sx={{
        maxWidth: 1200,
        mx: "auto",
        p: { xs: 2, md: 4 },
        bgcolor: "background.paper",
        borderRadius: 2,
        boxShadow: theme.shadows[1],
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => navigate("/usuarios")} sx={{ textTransform: "none" }}>
          Volver a usuarios
        </Button>
      </Box>
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: 600,
          color: "#333333",
        }}
      >
        Asignaciones para {user.name}
      </Typography>
      <Box
        sx={{
          "& .MuiAccordion-root": {
            mt: 1.5,
            borderRadius: "4px",
            overflow: "hidden",
          },
        }}
      >
        <AccordionComponent accordionInfo={accordionInfo} />
      </Box>
    </Box>
  );
};

export default UserDetail;
